import React from 'react';
import styles from './BehaviourContent.module.scss';
import BehaviourContentBody from './BehaviourContentBody/BehaviourContentBody';
import BehaviourContentHeader from './BehaviourContentHeader/BehaviourContentHeader';

const BehaviourContent = () => {
  return (
    <div className={styles.container}>
      <BehaviourContentHeader />
      <BehaviourContentBody />
    </div>
  );
};

export default BehaviourContent;
